import React from 'react';
import { ReactComponent as ChainPlus } from '../../assets/images/icons/chainPlus.svg';

export default function ChainPlusIcon(props) {
  return (
    <ChainPlus className={`icon ${props.className}`} />
  );
}